import React, { useState } from 'react'
import './group-popover.scss'
import { Column } from '@/components/layout/layout'
import { goodsModel } from '../../goods-storage/goods-library/modules/edit-goods/modules/model'
import useBemClass from '@/utils/hooks/useBEMClass'
import { useMount } from 'ahooks'
import { observer } from 'mobx-react'
import Iconfont from '@/components/iconfont/iconfont'
import { isExist } from '@/utils'
import classnames from 'classnames'
import PopoverConfirm from '@/components/popover-confirm/popover-confirm'

interface GroupPopoverProps {
    onConfirm: (groupId: number, secondId: number, name: string) => void
}

const GroupPopover: React.FC<GroupPopoverProps> = observer(props => {
    const cls = useBemClass('group-popover')

    const [groupId, setGroupId] = useState<number>(0)
    const [secondId, setSecondId] = useState<number>(0)
    const [name, setName] = useState<string>('')

    const [visible, setVisible] = useState(false)
    const hidden = () => {
        setVisible(false)
    }

    useMount(() => {
        goodsModel.initGoodsGroupInfo()
    })

    return (
        <PopoverConfirm
            arrowPointAtCenter
            trigger="click"
            types="success"
            visible={visible}
            onVisibleChange={visible => {
                setVisible(visible)
            }}
            content={
                <Column>
                    <div className={cls('title')} data-center>
                        选择分组
                    </div>
                    <Column className={cls('container')}>
                        {goodsModel.goodsGroup.map(group => (
                            <Column key={group.id} className={cls('line')}>
                                <div
                                    className={cls('group')}
                                    onClick={() => {
                                        setGroupId(Number(group.id))
                                        setSecondId(0)
                                        setName(group.name)
                                    }}
                                >
                                    {!isExist(group.secondary_group) && (
                                        <Iconfont
                                            name={groupId === group.id ? 'icon3danxuankai-20' : 'icon3danxuanguan-20'}
                                            size={20}
                                        />
                                    )}
                                    <div
                                        className={classnames(cls('tag'), {
                                            [cls('default')]: group.is_default,
                                        })}
                                        style={{
                                            marginLeft: !isExist(group.secondary_group) ? '16px' : '36px',
                                        }}
                                    >
                                        {group.name.charAt(0)}
                                    </div>
                                    <div className={cls('txt')}>{group.name}</div>
                                </div>
                                {isExist(group.secondary_group) &&
                                    group.secondary_group.map(second => (
                                        <div key={second.id}>
                                            <div
                                                className={cls('group')}
                                                onClick={() => {
                                                    setGroupId(Number(group.id))
                                                    setSecondId(second.id)
                                                    setName(`${group.name}/${second.name}`)
                                                }}
                                            >
                                                <Iconfont
                                                    name={
                                                        secondId === second.id
                                                            ? 'icon3danxuankai-20'
                                                            : 'icon3danxuanguan-20'
                                                    }
                                                    size={20}
                                                />
                                                <div
                                                    className={cls('txt')}
                                                    style={{
                                                        marginLeft: '64px',
                                                    }}
                                                >
                                                    {second.name}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </Column>
                        ))}
                    </Column>
                </Column>
            }
            disabled={!name}
            onConfirm={() => {
                hidden()
                props.onConfirm(groupId, secondId, name)
            }}
        >
            {props.children}
        </PopoverConfirm>
    )
})

export default GroupPopover
